import React from "react";

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="loadingio-spinner-spin-su4iz61v888 spinner">
        <div className="ldio-zun9bot0rhh">
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
